module.exports = __webpack_public_path__ + "img/loading-bars.9b094768.svg";